import axios from '../../utils/axios.js'

export const getMenuTree = (query) => axios.setAxiosGetPromise('menu/menuTree', query)

export const getMenuList = (query) => axios.setAxiosGetPromise('menu', query)

export const add = (options) => axios.setAxiosPostPromise('menu', options)

export const update = (query, options) => axios.setAxiosPutPromise('menu/' + query, options)

export const deleteMenu = (query) => axios.setAxiosDeletePromise('menu/' + query)

export const getAllMenuTree = (query) => axios.setAxiosGetPromise('menu/allMenuTree', query)

export const getMenuTemplateTree = (query) => axios.setAxiosGetPromise('menuTemplate/templateTree', query)



// WEBPACK FOOTER //
// ./src/services/system/menu.js